import React, { Component } from "react";
import { gql } from "@apollo/client";

import { apolloClient } from "../../index";

export default class ValidateUser extends Component {
  componentDidMount() {
    const variables = {
      token: this.props.match.params.token,
    };

    apolloClient
      .mutate({
        mutation: gql`
          mutation ValidateUserToken($token: String!) {
            validateToken(token: $token) {
              success
              email
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        if (result.data.validateToken.success) {
          this.props.history.push("/create-account/".concat(variables.token));
        }
      })
      .catch(() => {});
  }

  render() {
    return (
      <div>
        <p>Validating {this.props.match.params.token}</p>
      </div>
    );
  }
}
